<app-loading *ngIf="cargando || carEstados"></app-loading>
<div *ngIf="!cargando">
  <div [hidden]="carEstados">
    <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate id="fFormularioVentaAtributosValidarFacetec" name="nomFormularioVentaAtributosValidarFacetec">
      <div class="grid form-group">
        <div class="col-12">
          <div class="div-form col-6">
            <label>* {{ 'ATRIBUTOSVALIDARFACETEC.LBL_ATRIBUTOVALIDAR' | translate }}</label>
            <p-dropdown disableTab  id="idValidaFacetec" name="nomIdValidaFacetec"
                        [options]="lisValidacionesFace"
                        formControlName="idValidaFacetec"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
            ></p-dropdown>
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !f.idValidaFacetec.value">
              {{ 'ATRIBUTOSVALIDARFACETEC.LBL_ATRIBUTOVALIDAR' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
          <div class="div-form col-2 lg:col-offset-2" *ngIf="validarMatchLevelVisible()">
            <label>* {{ 'ATRIBUTOSVALIDARFACETEC.LBL_MATCHLEVEL' | translate }}</label>
            <input type="text" pInputText id="nivelCoincidencia" name="nomNivelCoincidencia"
                   autocomplete="off"
                   formControlName="nivelCoincidencia"
                   [minimo]="0"
                   [maxlength]="2"
                   numero-entero-reactive
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !validarMatchLevel()">
              {{ 'ATRIBUTOSVALIDARFACETEC.LBL_MATCHLEVEL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-12 md:col-12 lg:col-12">
          <div class="grid">
            <div class="div-form col-6">
              <p-checkbox label="{{ 'ATRIBUTOSVALIDARFACETEC.LBL_ANALIZAMOS' | translate}}" binary="true"
                          id="indicadorAnalizamos"
                          name="nomIndicadorAnalizamos"
                          formControlName="indicadorAnalizamos"></p-checkbox>
            </div>
            <div class="div-form col-6">
              <p-checkbox label="{{ 'ATRIBUTOSVALIDARFACETEC.LBL_DIGITAL' | translate}}" binary="true"
                          id="indicadorDigital"
                          name="nomIndicadorDigital"
                          formControlName="indicadorDigital"></p-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-group">
        <div class="col-12">
          <p-fieldset legend="{{'ATRIBUTOSVALIDARFACETEC.LBL_SINOCUMPLECRITERIO' | translate}}" class="overflow-y-unset">
            <div class="grid form-group">
              <div class="col-12" style="display: flex">
                <div class="div-form col-6">
                  <label><span *ngIf="!validarEstado()">*</span> {{ 'ATRIBUTOSVALIDARFACETEC.LBL_ESTADO' | translate }}</label>
                  <p-dropdown disableTab  id="idEstado" name="nomIdEstado"
                              [options]="lisEstados"
                              formControlName="idEstado"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !validarEstado()">
                    {{ 'ATRIBUTOSVALIDARFACETEC.LBL_ESTADO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
                <div class="div-form col-4 lg:col-offset-2">
                  <label>* {{ 'ATRIBUTOSVALIDARFACETEC.LBL_CAUSAL' | translate }}</label>
                  <p-dropdown disableTab  id="idCausal" name="nomIdCausal"
                              [options]="lisCausaSolicitudes"
                              formControlName="idCausal"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                              filter="filter"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && !validarCausal()">
                    {{ 'ATRIBUTOSVALIDARFACETEC.LBL_CAUSAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
                  </div>
                </div>
              </div>
            </div>
          </p-fieldset>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
          <button icon="fa fa-plus" label="{{'BTN_GUARDAR'| translate }}"
                  type="button" (click)="onSubmit()"
                  pButton></button>
        </div>
      </div>
    </form>
    <div>
      <div class="grid">
        <div class="col-12 md:col-6 lg:col-6">
        </div>
        <div class="col-12 md:col-6 lg:col-6">
          <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
                 (input)="dt.filterGlobal($event.target.value, 'contains')">
        </div>
      </div>
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table [columns]="columnas" #dt
                   [value]="lisValidacionFacetec" selectionMode="single" dataKey="idListaPlataformaDigitalVal"
                   [paginator]="true" [rows]="10"  paginatorPosition="bottom" [first]="pageActual"  (onPage)="paginaActual($event)">
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
                    class="text-center">
                  {{col.header}}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>>
            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td class="text-center">{{row.validacionFacetec}}</td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorAnalizamos" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">
                  <p-checkbox [(ngModel)]="row.indicadorDigital" binary="true" disabled="true"></p-checkbox>
                </td>
                <td class="text-center">{{row.estado}}</td>
                <td class="text-center">{{row.causal}}</td>
                <td class="text-center">
                  <div class="btn-group" role="group">
                    <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                            title="{{'BTN_EDITAR' | translate}}" pButton
                            (click)="editar(row)"></button>
                    <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                            title="{{'BTN_INHABILITAR' | translate}}" pButton
                            (click)="mensajeEliminar(row)"></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length">
                  {{ 'MSG_NOHAYREGISTROS' | translate}}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog #cd key="flujo-venta-validar-facetec">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
